export default __webpack_public_path__ + "static/media/daniel.791da3cb.png";